import { render, staticRenderFns } from "./MessageModel.vue?vue&type=template&id=770519fd&scoped=true"
import script from "./MessageModel.vue?vue&type=script&lang=js"
export * from "./MessageModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770519fd",
  null
  
)

export default component.exports